import Env from '../base/env';
import { module } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {};
    this.DOM.view = this.el.querySelector('video');
    this.VARS = {
      mode: this.el.getAttribute('data-mode'),
    };

    this.DOM.view.muted = true;
    this.DOM.view.setAttribute('webkit-playsinline', 'webkit-playsinline');
    this.DOM.view.setAttribute('playsinline', 'playsinline');

    gsap.delayedCall(0.1, () => {
      this.detect();
      this.listener();
    });
  }

  detect() {
    if (this.VARS.mode == 'video-all') {
      this.DOM.view.play();
    } else {
      if (Env.mobileCSS == true) {
        if (this.VARS.mode == 'video-mobile') {
          this.DOM.view.play();
        }
      } else {
        if (this.VARS.mode == 'video-desktop') {
          this.DOM.view.play();
        }
      }
    }
  }

  listener() {
    this.stListener = ScrollTrigger.create({
      trigger: this.DOM.view,
      end: 'bottom top-=40%',
      onEnter: () => {
        this.detect();
      },
      onEnterBack: () => {
        this.detect();
      },
      onLeave: () => {
        this.DOM.view.pause();
      },
      onLeaveBack: () => {
        this.DOM.view.pause();
      },
    });
  }

  destroy() {
    this.stListener.kill();
  }
}
